import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';
import { clsx } from 'clsx';

export const TONE_OF_VOICE_CHANNEL_EMOJI = {
  chat: '💬',
  email: '✉️',
};

export const ToneOfVoiceChannelField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch,
  compact,
}) => {
  const fieldValue = watch('pf_tone_of_voice_channel');

  useEffect(() => {
    if (readonly) {
      if (data) {
        setValue('pf_tone_of_voice_channel', data);
      } else if (field?.default_value?.value) {
        setValue('pf_tone_of_voice_channel', field?.default_value?.value);
      } else {
        setValue('pf_tone_of_voice_channel', '');
      }

      return;
    }

    if (fieldValue) {
      setValue('pf_tone_of_voice_channel', fieldValue);
      return;
    }

    if (data) {
      setValue('pf_tone_of_voice_channel', data);
    } else if (field?.default_value?.value) {
      setValue('pf_tone_of_voice_channel', field?.default_value?.value);
    } else {
      setValue('pf_tone_of_voice_channel', '');
    }
  }, [readonly, data, field]);

  return field ? (
    <div className={'flex flex-col gap-2.5'}>
      <div>
        <p className={'text-ebony text-sm font-medium'}>Channel</p>
      </div>
      <div>
        {Boolean(field?.options?.length) ? (
          <Controller
            control={control}
            name="pf_tone_of_voice_channel"
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <ToggleGroup
                className={clsx(
                  'flex gap-1.5 justify-items-stretch items-stretch w-full',
                  readonly && 'pointer-events-none',
                )}
                {...({ onChange } as any)}
                onValueChange={onChange}
                defaultValue={value}
                value={value}
                type="single"
              >
                {field.options.map((option) => {
                  return (
                    <ToggleGroupItem
                      className={'flex flex-1 items-center justify-center'}
                      key={option.key}
                      value={option.value}
                    >
                      {TONE_OF_VOICE_CHANNEL_EMOJI[option.key]
                        ? `${TONE_OF_VOICE_CHANNEL_EMOJI[option.key]} ${option.value}`
                        : option.value}
                    </ToggleGroupItem>
                  );
                })}
              </ToggleGroup>
            )}
          />
        ) : null}
      </div>
    </div>
  ) : null;
};
